import { Controller } from 'stimulus'
import { addInput, emptyInput } from 'components/input_actions'

export default class extends Controller {
  addInput = addInput;
  emptyInput = emptyInput;
}
